import { InvalidAuthStateError } from 'v2/errors';

import { authInitStorage, authStorage } from '../storages';
import { getAuthQueryParams } from '../helpers';
import { fetchAccessAuthToken } from '../api';
import type { ISamoletConfiguration } from '../types';
import { checkCurrentAuth } from './CheckCurrentAuth';

function getAuthParams() {
  const jwtAuthParams = authInitStorage.getJwtAuthParams();
  const authQueryParams = getAuthQueryParams();

  if (
    !jwtAuthParams?.state ||
    !jwtAuthParams?.verifier ||
    !authQueryParams.state ||
    !authQueryParams.code
  ) {
    throw new InvalidAuthStateError('incorrect query/localstorage data');
  }

  if (jwtAuthParams?.state !== authQueryParams.state) {
    throw new InvalidAuthStateError('incorrect state');
  }

  return { jwtAuthParams, authQueryParams };
}

export async function completeAuthorization(config: ISamoletConfiguration) {
  let jwtAuthParams = undefined;

  try {
    const authParams = getAuthParams();
    jwtAuthParams = authParams.jwtAuthParams;

    const authenticated = await checkCurrentAuth(config);

    if (!authenticated) {
      const { access_token, refresh_token } = await fetchAccessAuthToken({
        config,
        code: authParams.authQueryParams.code!, // eslint-disable-line @typescript-eslint/no-non-null-assertion
        verifier: jwtAuthParams.verifier,
      });

      await authStorage.setJwtAuthParams({
        access: access_token,
        refresh: refresh_token,
      });
      // Нет смысла обрабатывать исключение каким либо способом,
      // так как следующим действием в любом случае перенаправляем пользователя на другую страницу.
    }
  } catch {} // eslint-disable-line no-empty

  window.location.href = jwtAuthParams?.returnUrl ?? window.location.origin;
}
